import { cva } from 'class-variance-authority';

import { gapVariants } from './gap-variants';

export const containerVariants = cva(
  // `min-w-0` so a call site that constrains the button's width (e.g.
  // `className="min-w-0"` on a flex row) can actually shrink it; without it
  // the flex chain floors at the label's min-content width and overflows.
  'flex w-[inherit] items-center pointer-events-none min-w-0',
  {
    variants: {
      size: {
        tiny: '',
        small: '',
        medium: '',
      },
      loading: {
        true: 'justify-center',
        false: '',
      },
      contentDirection: {
        horizontal: '',
        vertical: 'flex-col',
      },
    },
    compoundVariants: [
      {
        contentDirection: 'horizontal',
        size: 'tiny',
        className: gapVariants({ size: 'tiny' }),
      },
      {
        contentDirection: 'horizontal',
        size: 'small',
        className: gapVariants({ size: 'small' }),
      },
      {
        contentDirection: 'horizontal',
        size: 'medium',
        className: gapVariants({ size: 'medium' }),
      },
    ],
    defaultVariants: {
      contentDirection: 'horizontal',
      loading: false,
    },
  },
);
